@if (!loading) {
  <h1 class="pb-4">{{ content.forgotPasswordHeadline }}</h1>
  <form>
    <div class="form-group">
      <label class="sr-only" for="forgotEmail">Email</label>
      <input type="email" class="form-control" id="forgotEmail" [formControl]="resetForm.get('email')" placeholder="Email">
    </div>
    <a class="btn btn-block btn-primary" (click)="submitForm()" disabled="loading">Send Reset</a>
    <div class="mt-4 text-center">
      <a [routerLink]="'/login'">Back to Log In</a>
    </div>
  </form>
} @else {
  <div class="center-div">
    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
  </div>
}

<app-feedback></app-feedback>

